export default __webpack_public_path__ + "static/media/portfolio_logo_white.13ce8df7.svg";